// TODO: Fix this type mapping
// SEE: https://nerdwallet.atlassian.net/browse/NWA-2850

const mapEnvironments = {
  local: 'dev',
  stage: 'stage',
  production: 'prod',
} as const

export function parseABSmartlyEnv(env: 'local' | 'stage' | 'production') {
  return mapEnvironments[env]
}
